module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-latin610.109f904.woff2";